import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthService } from '../_services/auth.service';
import { FirstLoginService } from '../first-login/first-login.service';

export const authGuard: CanActivateFn = async (): Promise<boolean | UrlTree> => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isAuthenticated()) {
    try {
      await authService.ensureValidToken(60000);
      return true;
    } catch (e: any) {
      if (authService.isNetworkError(e) && authService.getAuth()?.accessToken) {
        return true;
      }
    }
  }
  return router.parseUrl('/login');
};

export const guestGuard: CanActivateFn = (next: ActivatedRouteSnapshot): boolean | UrlTree => {
  const authService = inject(AuthService);
  const ftlService = inject(FirstLoginService);
  const router = inject(Router);

  // Reset FTL session flag on new login flow (like Flutter's resetFirstLoginNavigationFlag)
  ftlService.hasNavigatedToFirstLogin = false;

  // A fresh SSO handoff (Epic/SMART OTP or a temporary token) must always be allowed to
  // complete, even if a stale session is still in localStorage. Otherwise this guard would
  // redirect away from /login and drop the ?otp= query param before it can be redeemed,
  // leaving the user stuck on the login screen.
  if (next.queryParamMap.get('otp') || next.queryParamMap.get('temporaryToken')) {
    return true;
  }

  if (!authService.isAuthenticated()) {
    return true;
  }

  const user = authService.getUser();
  if (user && FirstLoginService.shouldShowFirstTimeLogin(user)) {
    return router.parseUrl('/first-login');
  }

  return router.parseUrl('/home');
};

